import { TableAccountIcon } from './TableAccountIcon';

/**
 * author: Michael Irigoyen
 * id 4E3E7C78-5217-4B8A-8B95-9DE8433CFADA
 * name table-account
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-account.svg
 * tags
 * - Account / User 
 */
export const TableUserIcon = TableAccountIcon;
export default TableUserIcon